import { z } from 'zod'

/**
 * Shared between the login form (React Hook Form resolver) and the
 * Cloudflare Pages Function that handles POST /api/auth/login — one
 * schema, so client-side and server-side validation never drift apart.
 */
export const loginSchema = z.object({
  email: z.string().trim().toLowerCase().email(),
  password: z.string().min(8).max(200),
})

export type LoginInput = z.infer<typeof loginSchema>

export const sessionUserSchema = z.object({
  id: z.string(),
  email: z.string().email(),
  name: z.string(),
  role: z.enum(['operator', 'manager']),
  avatarUrl: z.string().url().nullable(),
})

export type SessionUser = z.infer<typeof sessionUserSchema>
